<template>
  <HTMLReport ref="htmlReportRef" id="htmlReport" :header="true" 
    :id_unidade_operacao="get_id_unidade_oper()">
    <div v-if="recebimento">
      <div class="d-flex flex-column">
        <br />
        <br />
        <!-- Filtro -->
        <span class="font-weight-light">
          {{ recebimento.fl_protocolo ? 'Protocolo de Fatura' : ( recebimento.fl_envio_da_recepcao ? 'Protocolo de Envio da Recepção' : 'Protocolo de Entrega' ) }} - Nº
          <strong>{{recebimento.st_protocolo}}</strong>
        </span>
        <span class="font-weight-light">{{periodo}}</span>
        <span class="font-weight-light">
          Emissão:
          <strong>
            {{ getFormatDate(recebimento.dt_recebimento ? recebimento.dt_recebimento : $util.hoje(), "DD/MM/YYYY") }}
            {{ recebimento.dt_recebimento ? recebimento.dt_recebimento.substr(11,5) : $util.agora() }}
          </strong>
        </span>
        <span class="font-weight-light">
          Usuário:
          <strong>{{ recebimento.usuario ? recebimento.usuario.st_login : $store.state.user.st_login }}</strong>
        </span>
        <span class="font-weight-light">
          Id:
          <strong>P{{recebimento.id_recebimento}}</strong>
        </span>
        <br />
        
        <div v-if="dados">
          <div v-for="(operadora, io) in dados" :key="io">
            <span class="font-weight-light">
              Operadora:
              <strong>{{operadora.guias[0].plano.operadora.st_operadora}}</strong>
            </span>

            <!-- Tabela guias -->
            <table class="table table-sm" v-if="operadora.guias">
              <thead>
                <tr>
                  <th>Atend.</th>
                  <th>Guia</th>
                  <th>Matricula</th>
                  <th>Paciente</th>
                  <th>Profissional</th>
                  <th>Unidade</th>
                  <th>Guia Operadora</th>
                  <th>Senha</th>
                  <th class="text-right">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(guia, ig) in operadora.guias" :key="ig">
                    <td>#{{guia.id_atendimento}}</td>
                    <td>
                        {{guia.st_numero_interno}}
                        <span class="ml-1">{{ guia.ch_status }}</span>
                        <div><small>{{getFormatDate(guia.dt_criacao, "DD/MM/YYYY")}}</small></div>
                    </td>
                    <td>{{guia.atendimento.st_numero_carteira}}</td>
                    <td><small>{{guia.atendimento.paciente.st_nome}}</small></td>
                    <td><small>{{guia.atendimento.medico.st_nome_exibicao}}</small></td>
                    <td><small v-if="guia.atendimento.unidade_operacao">{{ guia.atendimento.unidade_operacao.st_sigla }}</small></td>
                    <td><small>{{guia.st_numero}}</small></td>
                    <td><small>{{guia.st_codigo_autorizacao}}</small></td>
                    <td class="text-right small">{{$util.formatMoeda(guia.valor_total.total)}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="8">
                    Total: 
                    <span class="badge badge-secondary ml-3">
                      {{ operadora.guias.length }}
                    </span>
                  </th>
                  <th class="text-right">
                    <strong>{{ $util.formatMoeda(total_guias(operadora.guias)) }}</strong>
                  </th>
                </tr>
              </tfoot>
            </table>

            <br />
          </div>
          
          <div>
            <table class="table table-sm">
              <tr>
                <th>
                  Total Geral: 
                  <span class="badge badge-secondary ml-3">
                    {{ lista_guias().length }}
                  </span>
                </th>
                <th class="text-right">
                  <strong>{{ $util.formatMoeda(total_guias(lista_guias())) }}</strong>
                </th>
              </tr>
            </table>
          </div>


        </div>
      </div>

    </div>
  </HTMLReport>
</template>

<script>
import _ from "lodash";
import * as moment from "moment";
import HTMLReport from "../../../components/relatorios/HTMLReport";

export default {
  data() {
    return {
      dados: null
    };
  },
  components: { HTMLReport },

  props: ["recebimento", "periodo"],

  methods: {
    get_id_unidade_oper () { 
      return _.get(this.recebimento, 'guia_recebimentos.0.guia.atendimento.unidade_operacao.id_unidade_operacao');
    },

    lista_guias() { 
      if ( !this.dados )
        return;

      return _.flatMap(this.dados, operadora => operadora.guias);
    },

    total_guias(guias) { 
      return guias.reduce((carry, guia) => { 
        return carry + guia.valor_total.total;
      }, 0);
    },
    agruparGuias(items) {
      this.dados = null;
      this.dados = items;
    },
    getFormatDate(date, format) {
      return moment(date, "YYYY-MM-DD").format(format);
    }
  }
};
</script>

<style>
</style>